import { useQuery } from '@tanstack/react-query';
import { CITypesApi } from '../api/ci-types';

export const LINKS_GRAPH_QUERY_KEY = 'cit-links-graph';

/** Shared by the CI type graph and links from monitoring dependency rules. */
export function useCITypeLinksGraph(
  ciTypeId: string | undefined,
  descendants = false,
) {
  return useQuery({
    queryKey: [LINKS_GRAPH_QUERY_KEY, ciTypeId, descendants],
    queryFn: () =>
      CITypesApi.getCITypeLinksGraph(ciTypeId!, descendants).then(
        (res) => res.data,
      ),
    enabled: !!ciTypeId,
    keepPreviousData: true,
  });
}
